import { masks } from 'components/label/masks'
import { PrintText, PrintTitle, SpaceLine } from 'components/print'
import React from 'react'
import { conformToMask } from 'react-text-mask'

import { DeclaracaoComparecimentoModel, Periodo } from './DeclaracaoComparecimentoView'

export interface DeclaracaoComparecimentoProps extends DeclaracaoComparecimentoModel {
  dataPorExtenso: string
}

export const DeclaracaoComparecimento = (props: DeclaracaoComparecimentoProps) => {
  const cpf = props.cidadao.cpf
    ? conformToMask(props.cidadao.cpf, masks.cpf, { guide: false }).conformedValue
    : undefined

  return (
    <>
      <PrintTitle title='Declaração de comparecimento' level={3} />
      <SpaceLine />
      <PrintText textStyles={{ marginLeft: '24px', marginRight: '24px' }}>
        {'Declaro que ' +
          (props.cidadao.nomeSocial ? props.cidadao.nomeSocial + ' (' + props.cidadao.nome + ')' : props.cidadao.nome) +
          (props.cidadao.cns ? ', CNS ' + props.cidadao.cns : '') +
          (cpf ? ', CPF ' + cpf : '') +
          ', permaneceu na ' +
          props.unidadeSaude.nome +
          ' no dia ' +
          props.iniciadoEm +
          (props.periodo === Periodo.PERSONALIZADO
            ? ' das ' + props.horarioEntrada + ' até às ' + props.horarioSaida
            : ' no turno ' + props.periodo) +
          (props.nomeAcompanhante ? ' com acompanhamento de ' + props.nomeAcompanhante.toLocaleUpperCase() : '') +
          '.'}
      </PrintText>
      <PrintText
        wrapperStyles={{
          marginTop: '100px',
          marginRight: '32px',
          alignSelf: 'flex-end',
        }}
        textStyles={{ fontSize: 10 }}
      >
        {props.unidadeSaude.endereco.municipio.uf.sigla +
          ' - ' +
          props.unidadeSaude.endereco.municipio.nome[0] +
          props.unidadeSaude.endereco.municipio.nome.substr(1).toLocaleLowerCase() +
          ', ' +
          props.dataPorExtenso +
          '.'}
      </PrintText>
    </>
  )
}
